import { combineReducers } from "redux";
import productreducer from './Product/reducer';
import leadReducer from './Lead/reducer';
import merchantReducer from './Merchant/reducer';
import globalReducer from './Global/reducer';
import userReducer from './User/reducer';
import invoicereducer from './Invoice/reducer';
import permissionReducer from './Function/reducer';
import lookuReducer from './lookup/reducer';
import internationalise from './Internationalise/reducer';
import auditReducer from './audit/reducer';
import clientReducer from './Client/reducer';
import salesOrderReducer from './SalesOrder/reducer'
import documentReducer from './Documents/reducer';
import customer from './Customer/reducer';
import template from './Template/reducer';
import dashboardChart from './dashboard/reducer';
import reports from './Reports/reducer';
import tasksReducer from './Tasks/reducer';
import workflowsReducer from './Workflows/reducer';
import telecallingReducer from './Telecalling/reducer';
import customizationReducer from './Customization/reducer';
import searchReducer from "./SearchReducer/reducer";

const rootReducer = combineReducers({
    client : clientReducer,
    salesOrder : salesOrderReducer,
    product: productreducer,
    lead: leadReducer,
    merchant: merchantReducer,
    global: globalReducer,
    owner: userReducer,
    invoice: invoicereducer,
    permission: permissionReducer,
    lookup: lookuReducer,
    internationalise: internationalise,
    audit: auditReducer,
    customer : customer,
    documents : documentReducer,
    template : template,
    chart: dashboardChart,
    reports : reports,
    tasks : tasksReducer,
    workflows : workflowsReducer,
    telecalling : telecallingReducer,
    customization : customizationReducer,
    search: searchReducer,
});

export default rootReducer;